import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import EmailList from './components/EmailList';
import EmailDetail from './components/EmailDetail';
import Header from './components/Header';

const API_BASE_URL = 'https://cloudflare-mailbox.lb2k.workers.dev';

function App() {
  const [emails, setEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEmails();
  }, []);

  const fetchEmails = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/emails`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      // Sort emails by date (newest first)
      data.sort((a, b) => new Date(b.date) - new Date(a.date));
      setEmails(data);
      setError(null);
    } catch (err) {
      setError('Failed to load emails. Please try again later.');
      console.error('Error fetching emails:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectEmail = (emailId) => {
    setSelectedEmail(emailId);
  };

  return (
    <div className="app-container">
      <Header refreshEmails={fetchEmails} />
      <Container fluid className="mt-4">
        <Row>
          <Col md={4} className="email-list-container">
            {loading && !emails.length ? (
              <div className="text-center p-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2">Loading emails...</p>
              </div>
            ) : error ? (
              <div className="alert alert-danger">{error}</div>
            ) : (
              <EmailList 
                emails={emails} 
                onSelectEmail={handleSelectEmail} 
                selectedEmailId={selectedEmail}
              />
            )}
          </Col>
          <Col md={8} className="email-detail-container">
            <EmailDetail 
              emailId={selectedEmail} 
              apiBaseUrl={API_BASE_URL} 
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
